import React, {ReactNode} from "react";
import {css} from "@emotion/css";
import cn from "classnames";

const styles = css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    grid-gap: 16px;
    align-items: center;
    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
`;

export const ColumnFields = ({children, className}:{children:ReactNode,className?:string})=>{
  return <div className={cn(styles, className)}>
    {children}
  </div>
}
